// Ссылки <head> для страниц с общей шапкой: стили шапки и подвала. Шрифты —
// в корневом head (src/lib/brand-head.ts).
import chromeCss from "./site-chrome.css?url";

export const SITE_CHROME_LINKS = [
  { rel: "stylesheet", href: chromeCss },
];
